import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import TemplateBanner from "../TemplateBanner";
import ExploreWidgetsBanner from "./ExploreWidgetsBanner";
import MasterFoodLibraryCard from "./MasterFoodLibraryCard";
import MealPlanSectionCard from "./MealPlanSectionCard";

const MealPlansLanding = ({
  mealPlanCountDetailed,
  mealPlanCountSimplified,
  bannerTitle,
  bannerSubtitle,
  bannerIcon,
  bannerGradientStart = "#00afe4",
  bannerGradientEnd = "#5bc500",
  onBack,
}) => {
  const { t } = useTranslation("coaching-portal");

  return (
    <>
      <header className="header-coaching-programs meal-plans-landing-header">
        <hgroup className="hgroup-templates">
          <div className="header-text w-full">
            <div className="flex items-center gap-4 mb-2">
              <SvgIcon
                src="/img/new-icons/back-button.svg"
                classNames="cursor-pointer"
                onClickFn={onBack}
              />
              <TemplateBanner
                icon={bannerIcon}
                title={bannerTitle}
                subtitle={bannerSubtitle}
                gradientStart={bannerGradientStart}
                gradientEnd={bannerGradientEnd}
              />
            </div>
          </div>
        </hgroup>
      </header>

      <div className="meal-plans-landing flex flex-col gap-4">
        <h3>{t("allTemplates.chooseASection.title")}</h3>

        <div className="flex flex-wrap items-start gap-6">
          <MasterFoodLibraryCard />
          <MealPlanSectionCard
            title={t("allTemplates.chooseASection.multiDayMealPlans.title")}
            description={t(
              "allTemplates.chooseASection.multiDayMealPlans.description"
            )}
            viewPlanText={t(
              "allTemplates.chooseASection.multiDayMealPlans.viewPlan"
            )}
            count={mealPlanCountDetailed}
            planMode="detailed"
          />
          <MealPlanSectionCard
            title={t("allTemplates.chooseASection.singleDayMealPlans.title")}
            description={t(
              "allTemplates.chooseASection.singleDayMealPlans.description"
            )}
            viewPlanText={t(
              "allTemplates.chooseASection.singleDayMealPlans.viewPlan"
            )}
            count={mealPlanCountSimplified}
            planMode="simplified"
          />
        </div>

        <ExploreWidgetsBanner />
      </div>
    </>
  );
};

MealPlansLanding.propTypes = {
  mealPlanCountDetailed: PropTypes.number,
  mealPlanCountSimplified: PropTypes.number,
  bannerTitle: PropTypes.string,
  bannerSubtitle: PropTypes.string,
  bannerIcon: PropTypes.string,
  bannerGradientStart: PropTypes.string,
  bannerGradientEnd: PropTypes.string,
  onBack: PropTypes.func,
};

export default MealPlansLanding;
